// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName___dnZV","productName":"Table_productName__1DPtJ"};